import { useApp } from "@/App";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function HeroSection() {
  const { selectedLocation } = useApp();
  const locationName = selectedLocation === "cestlice" ? "Čestlice" : "Butovice";

  const scrollToServices = () => {
    const el = document.querySelector("#services");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToBooking = () => {
    const el = document.querySelector("#booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const videoUrl = `${window.location.origin}/carspa_hero.mp4`;

  return (
    <section className="relative h-[60vh] md:h-[70vh] w-full overflow-hidden" data-testid="hero-section">
      {/* Video background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        className="absolute inset-0 w-full h-full object-cover"
        data-testid="hero-video"
      >
        <source
          src={videoUrl}
          type="video/mp4"
        />
      </video>

      {/* Gradient overlay */}
      <div className="absolute inset-0 video-gradient" />
      <div className="absolute inset-0 bg-black/40" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-24 md:pb-32 max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#39FF14] mb-6">
            {locationName} / Premium Detailing
          </p>

          <h1 className="text-4xl md:text-7xl lg:text-8xl font-black tracking-tighter uppercase leading-[0.9] mb-6">
            Dokonalost<br />
            <span className="text-[#39FF14] neon-text">v každém</span><br />
            detailu
          </h1>

          <p className="text-base md:text-lg text-zinc-400 max-w-lg leading-relaxed mb-10">
            Profesionální péče o váš vůz. Od ručního mytí po keramické povlaky —
            vaše auto si zaslouží to nejlepší.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToBooking}
              className="btn-skew bg-[#39FF14] text-black px-10 py-4 text-sm font-bold uppercase tracking-wider hover:bg-white transition-colors duration-300"
              data-testid="hero-booking-btn"
            >
              <span>Rezervovat termín</span>
            </button>
            <button
              onClick={scrollToServices}
              className="btn-skew border border-white/20 text-white px-10 py-4 text-sm font-bold uppercase tracking-wider hover:border-[#39FF14] hover:text-[#39FF14] transition-colors duration-300"
              data-testid="hero-services-btn"
            >
              <span>Naše služby</span>
            </button>
          </div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.6 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 cursor-pointer"
          onClick={scrollToServices}
        >
          <span className="text-[10px] tracking-[0.2em] uppercase text-zinc-600">Scroll</span>
          <ChevronDown className="w-4 h-4 text-zinc-600 animate-bounce" />
        </motion.div>
      </div>
    </section>
  );
}
